import { Timeline as PrimeTimeline } from "primereact/timeline"
export const Timeline = PrimeTimeline
